import FormSelectBox from '@views/components/Inputs/FormSelectBox';
import { useGetUrgencyCodesList } from '@views/screens/common/hooks/use-get-urgency-codes-list';
import i18n from 'i18next';

export const UrgencySelect = ({
  placeholder = i18n.t('translation:default.fields.shipmentType.placeholder'),
  label = i18n.t('translation:default.fields.shipmentType.label'),
  rules = [],
  name,
  editMode,
  dataTestId,
  isRequired,
}) => {
  const { data: options = [], isLoading } = useGetUrgencyCodesList();

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      isRequired={isRequired}
      rules={rules}
      name={name}
      editMode={editMode}
      dataTestId={dataTestId}
    />
  );
};
